import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import * as Teacher from '@/api/teacher.js'
import { waitHydration, State } from './game/auth.js'
import { FDB } from './game/firebase.js'

// cloud
import * as sAPI from './_cloud/v0-general/api/strapi.js'
import './_cloud/v0-general/css/main.css'

Vue.use(Router)

// document.body.style.background = ''
let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/cloud',
      component: () => import(/* webpackChunkName: "cloud-login" */ './_cloud/v0-general/ui/App.vue'),
      children: [
        {
          path: '',
          beforeEnter: (to, from, next) => {
            if (sAPI.LS.Profile) {
              next('/cloud/choose-role')
            } else {
              next()
            }
          },
          component: () => import(/* webpackChunkName: "cloud-login" */ './_cloud/v0-general/page/LandingLoginPage.vue')
        },
        {
          path: 'facebookArrive',
          component: () => import(/* webpackChunkName: "cloud-login" */ './_cloud/v0-general/page/AuthLoading.vue'),
          meta: {
            arrive: 'facebook'
          }
        },
        {
          path: 'twitterArrive',
          component: () => import(/* webpackChunkName: "cloud-login" */ './_cloud/v0-general/page/AuthLoading.vue'),
          meta: {
            arrive: 'twitter'
          }
        },
        {
          path: 'googleArrive',
          component: () => import(/* webpackChunkName: "cloud-login" */ './_cloud/v0-general/page/AuthLoading.vue'),
          meta: {
            arrive: 'google'
          }
          // beforeEnter: async (to, from, next) => {
          //   if (await sAPI.googleArrive()) {
          //     next('/cloud/choose-role')
          //   } else {
          //     next('/cloud')
          //   }
          // }
        },
        // {
        //   path: 'playdev/:gameID',
        //   beforeEnter: (to, from, next) => {
        //     if (sAPI.checkLogin()) {
        //       next()
        //     } else {
        //       next('/cloud')
        //     }
        //   },
        //   component: () => import(/* webpackChunkName: "clouddev" */ './_cloud/dev/DevGame.vue')
        // },
        {
          path: 'play/:gameID',
          beforeEnter: async (to, from, next) => {
            if (sAPI.checkLogin()) {
              next()
            } else {
              next('/cloud')
            }
          },
          component: () => import(/* webpackChunkName: "cloud-game" */ './_cloud/v0-general/game/Board.vue')
        },
        {
          path: 'counter/:gameID',
          beforeEnter: async (to, from, next) => {
            if (sAPI.checkLogin()) {
              next()
            } else {
              next('/cloud')
            }
          },
          component: () => import(/* webpackChunkName: "cloud-game" */ './_cloud/v0-general/game/Counter.vue')
        },
        {
          path: 'choose-role',
          beforeEnter: (to, from, next) => {
            if (sAPI.checkLogin()) {
              next()
            } else {
              next('/cloud')
            }
          },
          component: () => import(/* webpackChunkName: "cloud-landing" */ './_cloud/v0-general/page/ChooseRole.vue')
        },
        {
          path: 'lobby',
          beforeEnter: (to, from, next) => {
            if (sAPI.checkLogin()) {
              next()
            } else {
              next('/cloud')
            }
          },
          component: () => import(/* webpackChunkName: "cloud-lobby" */ './_cloud/v0-general/page/Lobby.vue')
        },
        {
          path: 'palms',
          beforeEnter: (to, from, next) => {
            if (sAPI.checkLogin() && sAPI.checkIsPALMS()) {
              next()
            } else {
              next('/cloud')
            }
          },
          component: () => import(/* webpackChunkName: "cloud-palms" */ './_cloud/v0-general/page/PALMS.vue')
        },
        {
          path: 'teacher',
          beforeEnter: (to, from, next) => {
            if (sAPI.checkLogin()) {
              next()
            } else {
              next('/cloud')
            }
          },
          component: () => import(/* webpackChunkName: "cloud" */ './_cloud/v0-general/page/Teacher.vue')
        },
        {
          path: 'teacher-login',
          beforeEnter: (to, from, next) => {
            if (sAPI.checkLogin()) {
              next()
            } else {
              next('/cloud')
            }
          },
          component: () => import(/* webpackChunkName: "cloud" */ './_cloud/v0-general/page/TeacherLogin.vue')
        },
        {
          path: 'analytics/:gameID/:title',
          beforeEnter: (to, from, next) => {
            if (!Teacher.State.jwt) {
              next('/teacher-login')
            } else {
              next()
            }
          },
          component: () => import(/* webpackChunkName: "cloud" */ './_cloud/v0-general/page/AnalyticsPage.vue')
        },
        {
          path: 'try-question/:questionID',
          name: 'cloud-try-question',
          beforeEnter: (to, from, next) => {
            if (!Teacher.State.jwt) {
              next('/teacher-login')
            } else {
              next()
            }
          },
          component: () => import('./_cloud/v0-general/yoqb-teacher/PreviewGame.vue')
        },
        {
          path: 'yoqb-maker/:questionID',
          name: 'cloud-yoqb-maker',
          beforeEnter: (to, from, next) => {
            if (!Teacher.State.jwt) {
              next('/teacher-login')
            } else {
              next()
            }
          },
          component: () => import('./_cloud/v0-general/yoqb-teacher/QuestionBuilder.vue')
        },
        {
          path: 'yoqb-folder/:folderID',
          name: 'cloud-yoqb-folder',
          beforeEnter: (to, from, next) => {
            if (!Teacher.State.jwt) {
              next('/teacher-login')
            } else {
              next()
            }
          },
          component: () => import('./_cloud/v0-general/yoqb-teacher/QuestionListView.vue')
        }
      ]
    },

    {
      path: '/buhk-cloud',
      component: () => import(/* webpackChunkName: "cloud-login" */ './_cloud/v0-buhk/ui/App.vue'),
      children: [
        {
          path: '',
          redirect: '/buhk-cloud/teacher-login'
        },
        // {
        //   path: '',
        //   component: () => import(/* webpackChunkName: "cloud-login" */ './_cloud/v0-buhk/page/LandingLoginPage.vue')
        // },
        // {
        //   path: 'facebookArrive',
        //   component: () => import(/* webpackChunkName: "cloud-login" */ './_cloud/v0-buhk/page/AuthLoading.vue'),
        //   meta: {
        //     arrive: 'facebook'
        //   }
        // },
        // {
        //   path: 'twitterArrive',
        //   component: () => import(/* webpackChunkName: "cloud-login" */ './_cloud/v0-buhk/page/AuthLoading.vue'),
        //   meta: {
        //     arrive: 'twitter'
        //   }
        // },
        // {
        //   path: 'googleArrive',
        //   component: () => import(/* webpackChunkName: "cloud-login" */ './_cloud/v0-buhk/page/AuthLoading.vue'),
        //   meta: {
        //     arrive: 'google'
        //   }
        //   // beforeEnter: async (to, from, next) => {
        //   //   if (await sAPI.googleArrive()) {
        //   //     next('/cloud/choose-role')
        //   //   } else {
        //   //     next('/cloud')
        //   //   }
        //   // }
        // },
        // {
        //   path: 'playdev/:gameID',
        //   beforeEnter: (to, from, next) => {
        //     if (sAPI.checkLogin()) {
        //       next()
        //     } else {
        //       next('/cloud')
        //     }
        //   },
        //   component: () => import(/* webpackChunkName: "clouddev" */ './_cloud/dev/DevGame.vue')
        // },
        {
          path: 'play/:gameID',
          beforeEnter: async (to, from, next) => {
            if (sAPI.checkLogin()) {
              next()
            } else {
              next('/cloud')
            }
          },
          component: () => import(/* webpackChunkName: "cloud-game" */ './_cloud/v0-buhk/game/Board.vue')
        },
        {
          path: 'choose-role',
          beforeEnter: (to, from, next) => {
            if (sAPI.checkLogin()) {
              next()
            } else {
              next('/cloud')
            }
          },
          component: () => import(/* webpackChunkName: "cloud-landing" */ './_cloud/v0-buhk/page/ChooseRole.vue')
        },
        {
          path: 'lobby',
          beforeEnter: (to, from, next) => {
            if (sAPI.checkLogin()) {
              next()
            } else {
              next('/cloud')
            }
          },
          component: () => import(/* webpackChunkName: "cloud-lobby" */ './_cloud/v0-buhk/page/Lobby.vue')
        },
        // {
        //   path: 'palms',
        //   beforeEnter: (to, from, next) => {
        //     if (sAPI.checkLogin() && sAPI.checkIsPALMS()) {
        //       next()
        //     } else {
        //       next('/cloud')
        //     }
        //   },
        //   component: () => import(/* webpackChunkName: "cloud-palms" */ './_cloud/v0-buhk/page/PALMS.vue')
        // },
        {
          path: 'teacher',
          beforeEnter: (to, from, next) => {
            if (sAPI.checkLogin()) {
              next()
            } else {
              next('/cloud')
            }
          },
          component: () => import(/* webpackChunkName: "cloud" */ './_cloud/v0-buhk/page/Teacher.vue')
        },
        {
          path: 'teacher-login',
          beforeEnter: (to, from, next) => {
            if (sAPI.checkLogin()) {
              next()
            } else {
              next('/cloud')
            }
          },
          component: () => import(/* webpackChunkName: "cloud" */ './_cloud/v0-buhk/page/TeacherLogin.vue')
        },
        {
          path: 'analytics/:gameID/:title',
          beforeEnter: (to, from, next) => {
            if (!Teacher.State.jwt) {
              next('/teacher-login')
            } else {
              next()
            }
          },
          component: () => import(/* webpackChunkName: "cloud" */ './_cloud/v0-buhk/page/AnalyticsPage.vue')
        },
        {
          path: 'try-question/:questionID',
          name: 'cloud-try-question',
          beforeEnter: (to, from, next) => {
            if (!Teacher.State.jwt) {
              next('/teacher-login')
            } else {
              next()
            }
          },
          component: () => import('./_cloud/v0-buhk/yoqb-teacher/PreviewGame.vue')
        },
        {
          path: 'yoqb-maker/:questionID',
          name: 'cloud-yoqb-maker',
          beforeEnter: (to, from, next) => {
            if (!Teacher.State.jwt) {
              next('/teacher-login')
            } else {
              next()
            }
          },
          component: () => import('./_cloud/v0-buhk/yoqb-teacher/QuestionBuilder.vue')
        },
        {
          path: 'yoqb-folder/:folderID',
          name: 'cloud-yoqb-folder',
          beforeEnter: (to, from, next) => {
            if (!Teacher.State.jwt) {
              next('/teacher-login')
            } else {
              next()
            }
          },
          component: () => import('./_cloud/v0-buhk/yoqb-teacher/QuestionListView.vue')
        }
      ]
    },
    // {
    //   path: '/',
    //   redirect: '/cloud'
    // },
    {
      path: '/',
      redirect: '/cloud'
      // beforeEnter (to, from, next) {
      //   // document.body.style.background = 'linear-gradient(-195deg, darkblue, #575800)'
      //   waitHydration().then(() => {
      //     if (State.user) {
      //       next('/choose-role')
      //     } else {
      //       next()
      //     }
      //   })
      // },
      // component: () => import('./game-ui/HomePage.vue')
    },
    {
      path: '/game-lobby',
      // beforeEnter (to, from, next) {
      // },
      component: () => import('./game-ui/GameLobbyPage.vue')
    },
    {
      path: '/game-play/:gameID',
      beforeEnter (to, from, next) {
        if (to.params.gameID) {
          let gameID = to.params.gameID
          FDB.ref(`/user-games/${gameID}`).once('value', (snap) => {
            let room = snap.val()
            if (room) {
              next()
            } else {
              FDB.ref(`/admin-games/${gameID}`).once('value', (snap) => {
                let room = snap.val()
                if (room) {
                  next()
                } else {
                  next('/game-lobby')
                }
              })
            }
          })
        } else {
          next('/game-lobby')
        }
      },
      component: () => import('./game-ui/GamePlayPage.vue')
    },
    {
      path: '/_test/:gameID',
      async beforeEnter (to, from, next) {
        await waitHydration()
        // console.log(State.user)
        if (!State.user) {
          next(`/login-ui?redirect=${to.fullPath}`)
          // return
        } else {
          next()
        }
        // if (to.params.gameID) {
        //   let gameID = to.params.gameID
        //   FDB.ref(`/user-games/${gameID}`).once('value', (snap) => {
        //     let room = snap.val()
        //     if (room) {
        //       next()
        //     } else {
        //       FDB.ref(`/admin-games/${gameID}`).once('value', (snap) => {
        //         let room = snap.val()
        //         if (room) {
        //           next()
        //         } else {
        //           next('/game-lobby')
        //         }
        //       })
        //     }
        //   })
        // } else {
        //   next('/game-lobby')
        // }
      },
      component: () => import('./_general/gameplay/CellGame.v2.vue')
    },
    {
      path: '/choose-role',
      component: () => import('./game-ui/Landing.vue')
    },
    {
      path: '/teacher-login',
      name: 'teacher-login',
      component: () => import('./game-ui/TeacherLogin.vue')
    },
    {
      path: '/buhk_old',
      name: 'buhk_old',
      component: () => import('./game-ui/BUHKLogin.vue')
    },
    {
      path: '/admin-page',
      name: 'admin-page',
      beforeEnter: async (to, from, next) => {
        await waitHydration()
        if (!Teacher.State.jwt) {
          next('/teacher-login')
        } else if (!State.user) {
          next(`/login-ui?redirect=/admin-page`)
        } else {
          next()
        }
      },
      component: () => import('./game-ui/AdminPage.vue')
    },
    {
      path: '/palms',
      name: 'palms',
      beforeEnter: async (to, from, next) => {
        await waitHydration()
        if (!Teacher.State.jwt) {
          next('/teacher-login')
        } else if (!State.user) {
          next(`/login-ui?redirect=/palms`)
        } else {
          next()
        }
      },
      component: () => import('./game-ui/AdminPagePALMS.vue')
    },
    {
      path: '/buhk-admin-page',
      name: 'buhk-admin-page',
      beforeEnter: async (to, from, next) => {
        await waitHydration()
        if (!Teacher.State.jwt) {
          next('/teacher-login')
        } else if (!State.user) {
          next(`/login-ui?redirect=/buhk-admin-page`)
        } else {
          next()
        }
      },
      component: () => import('./game-ui/BUHKAdminPage.vue')
    },
    {
      path: '/login-ui',
      component: () => import('./game-ui/LoginUI.vue')
    },
    {
      path: '/analytics/:gameID/:title',
      name: 'analytics-of-game',
      beforeEnter: (to, from, next) => {
        if (!Teacher.State.jwt) {
          next('/teacher-login')
        } else {
          next()
        }
      },
      component: () => import('./game-ui/AdminAnalytics.vue')
    },

    {
      path: '/try-question/:questionID',
      name: 'try-question',
      beforeEnter: (to, from, next) => {
        if (!Teacher.State.jwt) {
          next('/teacher-login')
        } else {
          next()
        }
      },
      component: () => import('./game/apps-yoqb/teacher/PreviewGame.vue')
    },
    {
      path: '/yoqb-maker/:questionID',
      name: 'yoqb-maker',
      beforeEnter: (to, from, next) => {
        if (!Teacher.State.jwt) {
          next('/teacher-login')
        } else {
          next()
        }
      },
      component: () => import('./game/apps-yoqb/teacher/QuestionBuilder.vue')
    },
    {
      path: '/yoqb-folder/:folderID',
      name: 'yoqb-folder',
      beforeEnter: (to, from, next) => {
        if (!Teacher.State.jwt) {
          next('/teacher-login')
        } else {
          next()
        }
      },
      component: () => import('./game/apps-yoqb/teacher/QuestionListView.vue')
    },
    // {
    //   path: '/game',
    //   // name: 'game',
    //   beforeEnter: (to, from, next) => {
    //     // FDB.ref('/')
    //     next()
    //   },
    //   component: () => import('./game/CellGame.vue')
    // },
    // {
    //   path: '/game/:gameID',
    //   // name: 'game',
    //   component: () => import('./game/CellGame.vue')
    // },

    {
      path: '/on-email-arrive',
      component: () => import('./game-ui/EmailArrive.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})

// router.beforeResolve((to, from, next) => {
//   document.querySelector('#ripple').style.visibility = 'visible'
// })

// document.querySelector('#ripple').style.visibility = 'visible'
// router.afterEach(() => {
//   setTimeout(() => {
//     document.querySelector('#ripple').style.visibility = 'hidden'
//   }, 2000)
// })

export default router
